"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.pBs = exports.pByteString = void 0;
var bytestring_1 = require("@harmoniclabs/bytestring");
var IRConst_1 = require("../../../../IR/IRNodes/IRConst.js");
var Term_1 = require("../../../Term/index.js");
var types_1 = require("../../../type_system/types.js");
var TermBS_1 = require("../UtilityTerms/TermBS.js");
function pByteString(_bs) {
    var _bs_ = _bs instanceof bytestring_1.ByteString ? _bs.clone() : new bytestring_1.ByteString(_bs);
    return (0, TermBS_1.addPByteStringMethods)(new Term_1.Term(types_1.bs, function (_dbn) { return IRConst_1.IRConst.byteString(_bs_); }, true));
}
exports.pByteString = pByteString;
exports.pBs = pByteString;
